/**
 *
 * @param {MainClassProps} main
 * @param {Map<String, any>} parent
 */
const addTimelineRefs = (main, parent) => {
  if (parent.get("is-timeline") && !parent.get("is-coordinate-based")) {
    const timelines = /** @type {Array<Map<String, any>>} */ (
      main.storage.get("timelines")
    );

    timelines.push(parent);
  }
};

export default addTimelineRefs;
